var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e2f9eb8e-472d-46df-9e4a-de874ae892b5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-6b55074f-dc7f-4392-80e8-5563b8715ca5 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6b55074f-dc7f-4392-80e8-5563b8715ca5",
    d: "M10.77,22.98c-.56,0-1.05-.11-1.34-.41-1.02-1.02.11-4.35.69-4.93l8.04-8.04c.82-.82,2.15-.82,2.96,0l1.28,1.28c.82.82.82,2.15,0,2.96l-8.04,8.04c-.41.41-2.21,1.1-3.58,1.1ZM19.63,11s-.05,0-.07.03l-8.04,8.04c-.15.24-.44,1.27-.51,1.92.66-.08,1.7-.37,1.98-.56l7.98-7.99s.04-.1,0-.13l-1.28-1.28s-.04-.03-.07-.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.c91dcae9f4c5b8dd7857e0b50b861650.svg";
export { ForwardRef as ReactComponent };